import Vue from 'vue'
import Vuex from 'vuex'

import app from './app'
import auth from './auth'
import projects from './projects'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    auth,
    projects
  }
})

export default store
